import React, {useEffect} from 'react';
import {useBenefactorById} from '../../hooks';
import {ErrorModal, useErrorHandler} from '../../../../shared';
import {BenefactorPaymentsTable} from '../../../../widgets';

interface BenefactorPaymentsInfoProps {
  benefactorId: string | undefined;
}

export const BenefactorPaymentsInfo = ({benefactorId}: BenefactorPaymentsInfoProps) => {
  const {handleError, isErrorModalOpen, errorInfo, handleClose} = useErrorHandler({
    resourceName: 'Платежные карты',
    title: 'Ошибка при получении платежных карт',
  });
  const {getBenefactorPaymentsInfo} = useBenefactorById(benefactorId || '');
  //eslint-disable-next-line @typescript-eslint/no-unused-vars
  const {data: paymentsInfo, error: paymentsInfoError, isLoading} = getBenefactorPaymentsInfo;

  useEffect(() => {
    if (paymentsInfoError) {
      handleError(paymentsInfoError as unknown as ApiError);
    }
  }, [paymentsInfoError, handleError]);

  return (
    <div>
      <BenefactorPaymentsTable payments={paymentsInfo} isLoading={isLoading} />
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </div>
  );
};
